import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import cn from 'classnames';

import styles from './styles.m.scss';

import { routes } from '../../routes';

import NavDropdown from './NavDropdown';

const AdminNavBar = () => (
  <nav className={cn(styles.tabs, 'row', 'mb-5')}>
    <div className="nav nav-tabs" id="dashboard-nav-tab" role="tablist">
      <NavLink to={routes.admin.users.root} className="nav-item nav-link">
        Users
      </NavLink>
      <NavDropdown baseUrl={routes.admin.backpack.root} title="System Data">
        <a href={routes.admin.backpack.announcements} className="dropdown-item">
          Announcements
        </a>
        <a href={routes.admin.backpack.certifications} className="dropdown-item">
          Certifications
        </a>
        <a href={routes.admin.backpack.certificationRequirements} className="dropdown-item">
          Certification Requirements
        </a>
        <a href={routes.admin.backpack.certificationResources} className="dropdown-item">
          Certification Resources
        </a>
        <a href={routes.admin.backpack.courseMaterials} className="dropdown-item">
          Course Materials
        </a>
        <a href={routes.admin.backpack.creditTypes} className="dropdown-item">
          Credit Types
        </a>
        <a href={routes.admin.backpack.discounts} className="dropdown-item">
          Discounts
        </a>
        <a href={routes.admin.backpack.emailDropdown} className="dropdown-item">
          Email Dropdowns
        </a>
        <a href={routes.admin.backpack.events} className="dropdown-item">
          Events
        </a>
        <a href={routes.admin.backpack.exams} className="dropdown-item">
          Exams
        </a>
        <a href={routes.admin.backpack.forum} className="dropdown-item">
          Forum
        </a>
        <a href={routes.admin.backpack.groups} className="dropdown-item">
          Groups
        </a>
        <a href={routes.admin.backpack.memberships} className="dropdown-item">
          Memberships
        </a>
        <a href={routes.admin.backpack.membershipResources} className="dropdown-item">
          Membership Resources
        </a>
        <a href={routes.admin.backpack.militaryInstallations} className="dropdown-item">
          Military Installations
        </a>
        <a href={routes.admin.backpack.pathways} className="dropdown-item">
          Pathways
        </a>
        <a href={routes.admin.backpack.quickbooksProducts} className="dropdown-item">
          Quickbooks Products
        </a>
        <a href={routes.admin.backpack.registrationFees} className="dropdown-item">
          Registration Fees
        </a>
        <a href={routes.admin.backpack.reportingPeriods} className="dropdown-item">
          Reporting Periods
        </a>
        <a href={routes.admin.backpack.serviceTypes} className="dropdown-item">
          Service Types
        </a>
        <a href={routes.admin.backpack.trainings} className="dropdown-item">
          Trainings
        </a>
        <a href={routes.admin.backpack.universities} className="dropdown-item">
          Universities
        </a>
        <a href={routes.admin.backpack.workAreas} className="dropdown-item">
          Work Areas
        </a>
        <a href={routes.admin.backpack.workAreaCategories} className="dropdown-item">
          Work Area Categories
        </a>
      </NavDropdown>
      <NavDropdown baseUrl={routes.certificationsAndTraining.root} title="Pending Approvals">
        <Link to={routes.admin.courseRegistrations.root} className="dropdown-item">
          Course Registrations
        </Link>
        <Link to={routes.admin.individualCeus.root} className="dropdown-item">
          Individual CEUs
        </Link>
        <Link to={routes.admin.groupCeus.root} className="dropdown-item">
          Group CEUs
        </Link>
        <Link to={routes.admin.experiences.root} className="dropdown-item">
          Experiences
        </Link>
        <Link to={routes.admin.extensions.root} className="dropdown-item">
          Extensions
        </Link>
        <Link to={routes.admin.memberships.root} className="dropdown-item">
          Memberships
        </Link>
      </NavDropdown>
    </div>
  </nav>
);

export default AdminNavBar;
